import React, { useContext, useEffect, useState } from 'react'
import { ChatbotContext, ChatbotContextPayload } from '../../../context/chatbotContext'
import { chatbotListInterface } from '../../../models/axiosModel';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import globalStyles from "../../../assets/styles/global.module.scss";
import styles from "../../../assets/styles/componentStyles/template.module.scss";
import { Grid, Typography } from '@mui/material';
import GlobalSearch from '../../utility/GlobalSearch/GlobalSearch';
import EmptyState from '../../global/emptyState';
import ChatbotEmptyStateIcon from "../../../assets/images/chatbot/chatbotEmptyState.png";
import GlobalButton from '../../utility/globalButton/button';
import { useNavigate } from 'react-router-dom';
import IconsColor from '../../utility/iconsColor';
import noDataFound from '../../../assets/CampaignNoDataFound.png';
import chatbotStyles from "../../../assets/styles/componentStyles/chatbotList.module.scss";
import individualAvatar from "../../../assets/chatbotProfileAvtar.png";
import ConfirmationPopover from '../../utility/confirmationPopover';
import { filterCustomChatbots } from '../../../utils/constants';


interface DeployChatbotDialogProps {
    pageName: string,
    showConfirmationPopover: boolean,
    setShowConfirmationPopover: React.Dispatch<React.SetStateAction<boolean>>,
    confirmationPopoverAnchorEl: HTMLButtonElement | null,
    setConfirmationPopoverAnchorEl: React.Dispatch<React.SetStateAction<HTMLButtonElement | null>>,
    handleCloseConfirmationPopover: () => void,
    onDeployClick: (chatbot_id: string) => void,
}
const DeployChatbotDialog: React.FC<DeployChatbotDialogProps> = ({ pageName, showConfirmationPopover, setShowConfirmationPopover, confirmationPopoverAnchorEl, setConfirmationPopoverAnchorEl, handleCloseConfirmationPopover, onDeployClick }) => {

    const { chatbotList, GetChatbotListApi } = useContext(ChatbotContext) as ChatbotContextPayload;
    const { setFlagLoading, flagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const [filteredChatBotList, setFilteredChatBotList] = useState<chatbotListInterface[] | null>(null);
    const [selectedChatbotId, setSelectedChatbotId] = useState<number>(0)
    // const [showConfirmationPopover, setShowConfirmationPopover] = React.useState(false);
    // const [confirmationPopoverAnchorEl, setConfirmationPopoverAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const navigate = useNavigate()

    // const innerHeight = 
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const query = event?.target?.value?.toLowerCase()
        if (chatbotList != null) {
            const chatbotFilterData = chatbotList.filter((chatbot: chatbotListInterface) => {
                return (chatbot.chatbot_name !== null && chatbot?.chatbot_name?.toLowerCase().includes(query))
            })
            setFilteredChatBotList(chatbotFilterData)
        }
    }

    useEffect(() => {
        if (!chatbotList) {
            (async () => {
                setFlagLoading({ ...flagLoading, flagRoundLoader: true });
                let chatBotResponse = await GetChatbotListApi()
                if (chatBotResponse?.status) {
                    if (chatBotResponse?.data?.length) {
                        // setFilteredChatBotList(chatBotResponse.data.filter((chatbot: any) => chatbot.chatbot_flag_public)) 
                        setFilteredChatBotList(chatBotResponse.data);
                    } else {
                        setFilteredChatBotList(null)
                    }
                }else{
                    handleError(chatBotResponse);
                }
                setFlagLoading({ ...flagLoading, flagRoundLoader: false });
            })();
        } else {
            // setFilteredChatBotList(chatbotList.filter((chatbot: any) => chatbot.chatbot_flag_public)); 
            setFilteredChatBotList(chatbotList);
        }
    }, []);

    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${styles.templateWrapper}`}>
                <Grid container  className={`${styles.chatbotGrid} ${styles.mainScreenPadding}`}>
                    <Grid item className={globalStyles.fullwidth}>
                        <Grid container mt={"10px"} justifyContent={{ xs: "start", sm: "end" }}>
                            <Grid item className={`${globalStyles.globalSearchbarSubItem}`}>
                                <GlobalSearch
                                    fullWidth
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleSearch(e) }}
                                    size="small"
                                    placeholder="Search"
                                />
                            </Grid>

                            <Grid item className={styles.listsMainContainer} mt={2}>
                                <Grid container>
                                    <>
                                        {filteredChatBotList && filterCustomChatbots(filteredChatBotList)?.length > 0 ?
                                            filterCustomChatbots(filteredChatBotList)?.map((bot: any, index: number) => {
                                                return (
                                                    <React.Fragment key={index}>
                                                        <Grid item xl={2.3} lg={3} md={4} sm={12} xs={12}
                                                            key={index}
                                                            className={chatbotStyles.personaCreatedList}
                                                        >
                                                            <Grid container>

                                                                <Grid item xs={12}>
                                                                    <Grid container className={globalStyles.startAlignment} >
                                                                        <Grid item key={index}
                                                                         className={`${chatbotStyles.chatbotProfileAvtarItem} ${bot?.chatbot_logo_id 
                                                                            ? chatbotStyles.transparentBackground 
                                                                            : chatbotStyles.defaultBackground}`} 
                                                                        >
                                                                            <img src={bot?.chatbot_logo_url ? bot.chatbot_logo_url : individualAvatar} alt="chatbot Icon" className={bot?.chatbot_logo_id ? chatbotStyles.chatbot_icon : chatbotStyles.default_icon} />
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item key={index} xs={12} className={chatbotStyles.chatbotNameItem}>
                                                                    <Typography component={'span'} className={`${chatbotStyles.chatbotHeadText} ${globalStyles.cardHeaderFontSize}`}>{bot.chatbot_name}</Typography>
                                                                </Grid>

                                                                <Grid item xs={12}>
                                                                    <Grid container className={globalStyles.wrapperGlobalPageHeader} >
                                                                        <Grid item className={chatbotStyles.messageBox}  >
                                                                            <Grid container className={chatbotStyles.conversationBoxContainer}>
                                                                                <Grid item className={chatbotStyles.conversationBoxItem}>
                                                                                    <IconsColor iconName="conversations" height="16" width="16" />
                                                                                </Grid>
                                                                                <Grid item>
                                                                                    <span className={chatbotStyles.conversationFontStyle}># </span>
                                                                                    <span className={chatbotStyles.conversationFontStyle}>{bot.total_chats}</span>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid item mt={2}>
                                                                            <GlobalButton buttonText={"Deploy"} className='linkChatbotButtonStyle' onClick={(e) => {
                                                                                setConfirmationPopoverAnchorEl(e.currentTarget);
                                                                                setSelectedChatbotId(bot.chatbot_id)
                                                                                setShowConfirmationPopover(true)
                                                                            }} />
                                                                        </Grid>

                                                                        <ConfirmationPopover
                                                                            open={selectedChatbotId == bot.chatbot_id ? showConfirmationPopover : false}
                                                                            anchorEl={confirmationPopoverAnchorEl}
                                                                            handleClose={() => { setSelectedChatbotId(0); handleCloseConfirmationPopover() }}
                                                                            onConfirmation={() => { onDeployClick(bot.chatbot_id) }}
                                                                            descriptionText={<p>Are you sure you want to deploy <span className={globalStyles.primaryFontWeight} >{bot.chatbot_name}</span> on <span className={globalStyles.primaryFontWeight}>{pageName}</span> ?</p>}
                                                                        />
                                                                    </Grid>
                                                                </Grid>

                                                            </Grid>
                                                        </Grid>
                                                    </React.Fragment>
                                                );
                                            })
                                            :
                                            (chatbotList !== null && filterCustomChatbots(chatbotList)?.length == 0 ?
                                                <EmptyState
                                                    height={'calc(100vh - 250px)'}
                                                    pageIcon={<img alt="chatbot" src={ChatbotEmptyStateIcon} style={{ width: "165px", height: "auto" }} />}
                                                    pageSubText={"No Chatbot Created Yet! Start With a New Chatbot"}
                                                    primaryActionBtn={<GlobalButton
                                                        buttonText={"New Chatbot"}
                                                        className='primaryButtonStyle'
                                                        onClick={() => { navigate("/createChatbot") }}
                                                        startIcon={<IconsColor iconName="plus" width="15px" height="15px" fillColor="#fff" />}
                                                    />}
                                                />

                                                : (filteredChatBotList !== null && filteredChatBotList.length == 0 &&

                                                    <Grid item xs={12} className={styles.noDataFoundItem} sx={{ height: "calc(100vh - 300px) !important" }}>
                                                        <EmptyState
                                                            height={'calc(100vh - 300px) !important'}
                                                            pageIcon={<img alt="chatbot" src={noDataFound} />}
                                                            pageText={"No Data Found!"}
                                                        />
                                                    </Grid>
                                                )
                                            )
                                        }
                                    </>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default DeployChatbotDialog
